import { useState,useEffect } from "react";
import { motion } from "framer-motion";
import { BookOpen, Eye, User, FileText, Calendar, Users, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export default function Sad({ 
  accent = "#115e32",
  pageTitle = "Students Affairs Division | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  const tabs = [
    { id: "about", label: "About SAD", icon: <BookOpen size={18} /> },
    { id: "vision", label: "Vision and Mission", icon: <Eye size={18} /> },
    { id: "message", label: "Message from the Director", icon: <User size={18} /> },
    { id: "report", label: "Submit a Report", icon: <FileText size={18} /> },
    { id: "event", label: "Plan an Event", icon: <Calendar size={18} /> },
    { id: "org", label: "Student Organization", icon: <Users size={18} /> },
    { id: "contact", label: "Contact SAD", icon: <Phone size={18} /> },
  ];

  const [activeTab, setActiveTab] = useState("about");

  const content = {
    about: (
      <p>        
		The Student Affairs Division is here to support and foster your intellectual and personal growth and help you explore and experience the different aspects of University life. We care about you, your studies, your social growth, your well-being and your future and want to help you enjoy a great UCTC experience.
      </p>
    ),
    vision: (
      <p>
        <strong>Vision:</strong><br/>
		Students inspired and supported to engage in a transformative university experience that shapes their evolving understanding of self, community, and their contributions in a global society.

		<br/><br/><strong>Mission:</strong><br/>
		Founded on a broad-based commitment to student success in and out of the classroom, the Student Affairs Division provides a framework for the metacurricular experience with emphasis on the holistic development of the student that facilitates life-long growth in the areas of:
		<ul class="space-y-4">
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">a)</span>
			  <p class="text-gray-700 leading-relaxed">
				Intellectual and artistic curiosity
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">b)</span>
			  <p class="text-gray-700 leading-relaxed">
				Personal well-being
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">c)</span>
			  <p class="text-gray-700 leading-relaxed">
				Professional acumen
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">d)</span>
			  <p class="text-gray-700 leading-relaxed">
				Leadership
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">e)</span>
			  <p class="text-gray-700 leading-relaxed">
				Social responsibility
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">f)</span>
			  <p class="text-gray-700 leading-relaxed">
				Community engagement
			  </p>
			</li>
		</ul>		
		Central to our success is a commitment to cultivating deep and meaningful one-to-one relationships with students. We build and sustain collaborative relationships throughout the university to best serve the needs of our student body. Programs, services, and efforts are dedicated to the development of an engaged community among students, faculty, staff and alumni where meaningful and authentic exchanges are valued. Student Affairs Division staff help students navigate and reflect upon challenges and transitions, and we empower them to become architects of their own learning and development.
      </p>
    ),
    message: (
      <p>
        "Our mission is to ensure that students at UCTC thrive both inside and
        outside the classroom. The Student Affairs Division is here to guide and
        support you in every step of your academic journey." – Director, SAD
      </p>
    ),
    report: (
      <p>
        Student success, safety, and wellbeing are a priority at University of Creative Technology, Chittagong (UCTC)
		<br/>If you are experiencing an issue that impacts your ability to succeed at UCTC, please let us know by submitting a report. The Student Affairs Division is ready to help you.
		<br/>The Student Affairs Division (SAD) can provide assistance and support in the following areas.
		<ul class="space-y-4">
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">a)</span>
			  <p class="text-gray-700 leading-relaxed">
				Academic Concerns (advising, attendance, grade appeals, reinstatement to UCTC)
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">b)</span>
			  <p class="text-gray-700 leading-relaxed">
				Administrative Concerns (financial aid concerns, appeals, drop/add issues)
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">c)</span>
			  <p class="text-gray-700 leading-relaxed">
				Behavior Concerns (disruptive behavior in class, sudden behavior change, possible conduct policy violations)
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">d)</span>
			  <p class="text-gray-700 leading-relaxed">
				Bias Concerns (harassment and discrimination)
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">e)</span>
			  <p class="text-gray-700 leading-relaxed">
				Personal Concerns (relationship or family issues, adjustment to UCTC)
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#d4af37] font-bold">f)</span>
			  <p class="text-gray-700 leading-relaxed">
				Wellness Concerns (class attendance, mental health)
			  </p>
			</li>
		</ul>
		<strong><a href="/submit-report" className="text-blue-600 hover:text-blue-800 transition duration-200">To request help submit a Report.</a></strong>
      </p>
    ),
    event: (
      <p>
        So, you’re planning an event on the University of Creative Technology Chittagong campus—but you’re a student, not an event planner. You’ve come to the right place.Student Affairs’ Division help over 30 events happen on the UCTC campus each semester. Let our office support your planning so that you can have a safe and successful event at UCTC.
      </p>
    ),
    org: (
      <p>
        <strong>Join a Student Organization</strong><br/>
		<h1 className="text-2xl md:text-3xl font-bold text-[#2563eb]">Lead, join, or create a student org</h1>
		Student organizations are responsible for many of the discussions, activities, and traditions we value at UCTC.They also are responsible for upholding university policies, taking accountability for their members’ actions, and a whole host of managerial tasks such as finding funding, recruiting members, and promoting events.Here’s everything you need to know about joining, managing, or creating your own student organization at UCTC.
		<Link to="https://www.uctc.edu.bd/assets/files/Club-Leader-Position-Information.pdf" className="inline-block px-5 py-2 rounded-full bg-[#1f6da8] text-white font-semibold hover:bg-[#164f7c] transition animate-pulse">Download PDF</Link>
		<br/><br/>
		<strong>Create a new Student Organization</strong><br/>
		<h1 className="text-2xl md:text-3xl font-bold text-[#2563eb]">Create your own student organization</h1>
		If you are enrolled at UCTC, you can start a student organization by registering the organization with Student Affairs’ Division. But first, check CLUBs linkif your organization already exists.
      </p>
    ),
    contact: (
      <p>
		<strong>To request help, contact Student Affairs Division to the following;</strong><br/>
		<strong>Location:</strong> 1st Floor, UCTC Campus<br/>
		<strong>Hours:</strong> Monday through Saturday, 9.00 AM to 6.00 PM<br/>
        <strong>Email:</strong> sad@uctc.edu.bd <br />
        <strong>Phone:</strong> 8801707507071 <br />
        <strong>Mailing Address:</strong> Student Affairs Division, University of Creative Technology, Chittagong, 1084, Near New Chandgaon Police Station, Shah Amanat Bridge Connecting Road, Bahaddarhat, Chittagong, Bangladesh
      </p>
    ),
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffdf7] to-white">
      {/* Hero Section with SVG */}
      <section className="relative bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE] text-[#014864] py-20 overflow-hidden">
        {/* SVG Wave */}
        <svg
          className="absolute bottom-0 left-0 w-full h-20 text-white"
          viewBox="0 0 1440 320"
          fill="currentColor"
        >
          <path
            fillOpacity="1"
            d="M0,192L80,202.7C160,213,320,235,480,224C640,213,800,171,960,144C1120,117,1280,107,1360,101.3L1440,96V320H0Z"
          ></path>
        </svg>
        <div className="relative container mx-auto text-center z-10">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold"
          >
            Student Affairs Division
          </motion.h1>
          <p className="mt-4 text-lg opacity-90">
            Supporting students’ academic journey, leadership, and campus life.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="container mx-auto px-6 py-16 grid md:grid-cols-4 gap-8">
        {/* Left Menu */}
        <div className="col-span-1 bg-white rounded-xl shadow-lg p-6">
          <ul className="space-y-3">
            {tabs.map((tab) => (
              <li key={tab.id}>
                <button
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 w-full px-4 py-2 rounded-lg text-left transition ${
                    activeTab === tab.id
                      ? "bg-gradient-to-r from-[#2563eb] to-[#014864] text-white shadow"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {tab.icon} {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Right Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="col-span-3 bg-white rounded-xl shadow-lg p-8 text-gray-700 leading-relaxed"
        >
          {content[activeTab]}
        </motion.div>
      </section>
    </div>
  );
}
